const RATING_PERCENT_MULTIPLIER = 100;

export default function formatCharacterRatingScore(ratingScore?: number | null): string | undefined {
  if (ratingScore == null || Number.isNaN(ratingScore)) {
    return undefined;
  }

  return `${Math.round(ratingScore * RATING_PERCENT_MULTIPLIER)}%`;
}
